export const PERSONAL_DATA = {
    documentoDeIdentidad: null,
};

export const WORK_DATA = {
    situacionLaboral: null,
};

export const ECONOMIC_DATA = {
    confirmada: null,
};

module.exports = {
    PERSONAL_DATA,
    ECONOMIC_DATA,
    WORK_DATA,
}
